/**
 * Fixed Header with headroom.js
 * @dependencies headroom.js
 */

import Headroom from 'headroom.js'

const sizeChangeEvents = ['resize', 'orientationchange'];
const sizeChangeCallbacks = [];
const headroomInstances = [];

// Header Element
const headerEl = document.querySelector('.js-fixed-nav');

if (headerEl) {
  const calcHeaderHeight = () => {
    const headerElHeight = headerEl.offsetHeight;
    const topHeight = headerEl.querySelector('.top').offsetHeight;
    const navbarHeight = headerEl.querySelector('.navbar').offsetHeight;

    document.documentElement.style.setProperty('--top-height', ` -${topHeight}px`);
    document.documentElement.style.setProperty('--header-height', ` ${headerElHeight}px`);
    document.documentElement.style.setProperty('--navbar-height', ` ${navbarHeight}px`);
  }

  sizeChangeCallbacks.push(calcHeaderHeight);

  const topHeight = headerEl.querySelector('.top').offsetHeight;
  const fixedHeader = new Headroom(headerEl, {
    offset: topHeight,
    classes: {
      // when element is initialised
      initial: "initialized",
      // when scrolling up
      pinned: "is-pinned",
      // when scrolling down
      unpinned: "is-unpinned",
      // when above offset
      top: "is-top",
      // when below offset
      notTop: "is-not-top",
      // when at bottom of scoll area
      bottom: "is-bottom",
      // when not at bottom of scroll area
      notBottom: "is-not-bottom"
    }
  });

  headroomInstances.push(fixedHeader);
}

const tocElement = document.querySelector('.js-fixed-toc');
if (tocElement) {
  const calcTocHeight = () => {
    const tocHeight = tocElement.offsetHeight;
    document.documentElement.style.setProperty('--toc-height', `${tocHeight}px`);
  }

  sizeChangeCallbacks.push(calcTocHeight);

  let offset = tocElement.getBoundingClientRect().top;
  const navbar = document.querySelector(".navbar");
  if (navbar) {
    offset -= navbar.offsetHeight;
  }

  const fixedTOC = new Headroom(tocElement, {
    offset,
    classes: {
      // when element is initialised
      initial: "initialized",
      // when scrolling up
      pinned: "is-pinned",
      // when scrolling down
      unpinned: "is-unpinned",
      // when above offset
      top: "is-top",
      // when below offset
      notTop: "is-not-top",
      // when at bottom of scoll area
      bottom: "is-bottom",
      // when not at bottom of scroll area
      notBottom: "is-not-bottom"
    }
  });

  headroomInstances.push(fixedTOC);
}

window.addEventListener('load', () => {
  headroomInstances.forEach((instance) => {
    instance.init();
  });
  sizeChangeCallbacks.forEach((callback) => callback());
});

sizeChangeEvents.forEach((event) => {
  sizeChangeCallbacks.forEach((callback) => {
    window.addEventListener(event, callback);
  });
});
